import React from 'react';

import { AllFilters as AllFiltersProvider } from 'components/Filters';

import { Grid } from '@gogame/components';
import { useIsAllowed } from '@gogame/permissions';

import { PERMISSION_ACTION_SMART_RULES_ADMIN } from 'scenes/SmartRules/constants';

import Filters from './filters';

const AllFilters = ({ open, onClose, onExited }) => {
  const isAllowed = useIsAllowed();

  return (
    <AllFiltersProvider
      title={'Filters'}
      open={open}
      onClose={onClose}
      onExited={onExited}
    >
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <Filters.Created />
        </Grid>
        <Grid item xs={4}>
          <Filters.Statuses />
        </Grid>
        {!isAllowed(PERMISSION_ACTION_SMART_RULES_ADMIN) ? (
          <Grid item xs={4}>
            <Filters.ShowMode />
          </Grid>
        ) : null}
        <Grid item xs={4}>
          <Filters.Type withFavoriteActions={true} />
        </Grid>
        <Grid item xs={4}>
          <Filters.Affiliates
            dropdownWidth={'440px'}
            withFavoriteActions={true}
          />
        </Grid>
        <Grid item xs={4}>
          <Filters.Channels withFavoriteActions={true} />
        </Grid>
        <Grid item xs={4}>
          <Filters.Networks withFavoriteActions={true} />
        </Grid>
        <Grid item xs={4}>
          <Filters.Applications withFavoriteActions={true} />
        </Grid>
        <Grid item xs={4}>
          <Filters.Platforms withFavoriteActions={true} />
        </Grid>
        <Grid item xs={4}>
          <Filters.CreatedBy withFavoriteActions={true} />
        </Grid>
      </Grid>
    </AllFiltersProvider>
  );
};

export default AllFilters;
